import { render, staticRenderFns } from "./Breadbox.vue?vue&type=template&id=f6374c0a"
import script from "./Breadbox.vue?vue&type=script&lang=js"
export * from "./Breadbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports